import { CompletionRecordStatus } from '../enums/InventoryEnum';

export default class InventoryManageModel {

  constructor(data) {

    // TODO: add validation for mandatory items
    let template = {
      completionRecordId: null,
      inventoryId: null,
      description: null,
      created: null,
      started: null,
      completed: null,
      hasReport: null,
      inventoryName: null,
      inventoryVersion: null
    };

    this.data = data ? data : template;
  }


  getCompletionRecordId = () => {
    return this.data.completionRecordId;
  }
  setCompletionRecordId = (value) => {
    this.data.completionRecordId = value;
  }

  getInventoryId = () => {
    return this.data.inventoryId;
  }
  setInventoryId = (value) => {
    this.data.inventoryId = value;
  }

  getDescription = () => {
    return this.data.description;
  }
  setDescription = (value) => {
    this.data.description = value;
  }

  getCreated = () => {
    return this.data.created;
  }
  setCreated = (value) => {
    this.data.created = value;
  }

  getStarted = () => {
    return this.data.started;
  }
  setStarted = (value) => {
    this.data.started = value;
  }

  getCompleted = () => {
    return this.data.completed;
  }
  setCompleted = (value) => {
    this.data.completed = value;
  }

  getHasReport = () => {
    return this.data.hasReport;
  }
  setHasReport = (value) => {
    this.data.hasReport = value;
  }

  getInventoryName = () => {
    return this.data.inventoryName;
  }
  setInventoryName = (value) => {
    this.data.inventoryName = value;
  }

  getInventoryVersion = () => {
    return this.data.inventoryVersion;
  }
  setInventoryVersion = (value) => {
    this.data.inventoryVersion = value;
  }


  getId = () => {
    return this.getCompletionRecordId();
  }

  getCompletionStatus = () => {
    let isComplete = this.getStarted() !== null & this.getCompleted() !== null;
    let isStarted = this.getStarted() !== null & this.getCompleted() === null;
    let isReportCreated = this.getHasReport() === 1;

    if (isComplete) {
      return CompletionRecordStatus.COMPELTE;
    } 

    if (isStarted && !isReportCreated) {
      return CompletionRecordStatus.INCOMPLETE;
    }

    if (isStarted && isReportCreated) {
      return CompletionRecordStatus.FORCE_COMPLETE;
    }

    return CompletionRecordStatus.PENDING;
  }

  toJson = () => {
    return JSON.stringify(this.data);
  }

}    